import React from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { includes } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";

import CloseIcon from "../../Common/CloseIcon";
import MeasuredTemperature from "./MeasuredTemperature";

import {
  getThreshold,
  getTemperatureByOperation,
} from "../../../utils/temperature";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  dialogPaper: {
    padding: "0px 40px 12px",
    minWidth: "710px",
    minHeight: "600px",
  },
  buttonIcon: {
    boxShadow: `0px 1px 2px 0px ${colors.black24}, 0px 1px 3px 0px ${colors.black12}`,
    padding: "0px !important",
    minWidth: "0px",
    "& img": {
      width: "32px",
    },
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "-30px",
  },
};

const MeasuredTemperatureDialog = (props) => {
  const {
    classes,
    open,
    onOpen,
    onClose,
    language,
    data /*, hasLeft*/,
  } = props;

  const maxTemperature = getTemperatureByOperation(data, "max");
  const threshold = getThreshold(data);
  const temperatureStatus =
    /*hasLeft &&*/ maxTemperature < threshold
      ? "green"
      : maxTemperature >= threshold
      ? "red"
      : null;

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          if (includes(["red", "green"], temperatureStatus)) {
            onOpen();
          } else if (props.noTemperatureAction) {
            props.noTemperatureAction();
          }
        }}
        className={classes.buttonIcon}
        disabled={
          !props.noTemperatureAction &&
          !includes(["red", "green"], temperatureStatus)
        }
      >
        <img
          src={
            temperatureStatus === "red"
              ? images.temperatureButtonRed
              : temperatureStatus === "green"
              ? images.temperatureButtonGreen
              : images.temperatureButtonDisabled
          }
          style={{ display: "block" }}
          alt="temperature"
        />
      </Button>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "12px 0px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {I18n.get("site_measuredTemp").toUpperCase()}
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={onClose} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <MeasuredTemperature
              data={data}
              startTime={props.startTime}
              language={language}
              dialog={true}
            />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(MeasuredTemperatureDialog)
);
